// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oEyO","largestCol":"styles_largestCol__2trxB","smallestCol":"styles_smallestCol__3IKEu"};